var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H7ZM10.125 13.487L16.0247 7.58726C16.3926 7.23198 16.9773 7.23706 17.3389 7.59868C17.7005 7.96031 17.7056 8.54503 17.3503 8.91289L10.7878 15.4754C10.4217 15.8414 9.8283 15.8414 9.4622 15.4754L6.6497 12.6629C6.29442 12.295 6.2995 11.7103 6.66112 11.3487C7.02275 10.9871 7.60747 10.982 7.97533 11.3373L10.125 13.487Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFull);
export default __webpack_public_path__ + "static/media/checkbox_full.1b33beff30d136c9d15a8a15c20c43df.svg";
export { ForwardRef as ReactComponent };